import { KText } from '@/ui-library/components/text';
import { Radio, RadioGroup, Stack, Flex, Icon } from '@chakra-ui/react';
import { useField } from 'formik';

export const RadioGroupField = ({ item, field }) => {
  const {
    options,
    name,
    styles,
    disabled = false,
    radioStyles = {},
    radioWrapperStyles = {},
    radioLabelStyles = {},
    radioIconStyles = {},
    radioOptionsDirection = 'row',
    editable = true,
    onChange = () => {},
  } = item;
  // eslint-disable-next-line no-unused-vars
  const [formField, meta, helpers = {}] = useField(name);
  const { setValue } = helpers || {};

  const handleChange = (value) => {
    setValue(value);
    onChange?.(value);
  };

  return (
    <div>
      <RadioGroup
        pointerEvents={!editable ? 'none' : 'auto'}
        onChange={handleChange}
        value={field?.value}
        id={name}
      >
        <Stack direction={radioOptionsDirection} {...styles}>
          {options?.map((option) => (
            <Radio
              variant="primary"
              key={option?.value}
              value={option?.value}
              isDisabled={option.disabled || disabled}
              alignItems="start"
              {...radioStyles}
            >
              <Flex
                flexDir="column"
                {...radioWrapperStyles}
                {...option?.radioWrapperStyles}
              >
                {option?.icon && (
                  <Icon
                    as={option?.icon}
                    className="primary-900"
                    {...radioIconStyles}
                    {...option?.radioIconStyles}
                  />
                )}
                <KText
                  size="sm-medium"
                  mb="2px"
                  {...radioLabelStyles}
                  {...option?.radioLabelStyles}
                >
                  {option?.label}
                </KText>
                {option?.desc && (
                  <KText fontSize="sm" color="secondary-700">
                    {option?.desc}
                  </KText>
                )}
              </Flex>
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
    </div>
  );
};
